export function buildTripPortalUrl(circuitId, tripDateId) {
  const portalUrl = (window.__ENV__ || {}).PORTAL_URL || "";
  return `${portalUrl}/trips/${circuitId}/${tripDateId}`;
}
